import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Formik, Field } from 'formik';
import { Link } from 'react-router-dom';
import { Select } from '../../../../../../_metronic/_partials/controls';
import Numeric from '../../../../../components/Numeric';
import CheckBox from '../../../../../components/CheckBox';
import { initialBox, boxStatusList, receivedTypeList } from '../BoxesUIHelpers';
import BoxItems from './BoxItems';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      let date = action.payload.receivedDate
        ? action.payload.receivedDate
        : new Date().toISOString().slice(0, 10);
      console.log('receivedDate', action.payload.receivedDate, date);
      return {
        ...state,
        orderCode: action.payload.orderCode,
        orderDate: action.payload.orderDate,
        trackingId: action.payload.trackingId,
        websiteCode: action.payload.websiteCode,
        boxStatus: action.payload.boxStatus,
        cargoCode: action.payload.cargoCode,
        check: action.payload.check,
        weight: action.payload.weight,
        currencyRate: parseFloat(action.payload.currencyRate),
        cargoFee: parseFloat(action.payload.cargoFee),
        cargoCostMnt: action.payload.cargoCostMnt
          ? parseFloat(action.payload.cargoCostMnt)
          : parseFloat('0.00'),
        receivedDate: date,
        receivedType: Number(action.payload.receivedType),
        customTaxAmount: action.payload.customTaxAmount
          ? parseFloat(action.payload.customTaxAmount)
          : parseFloat('0.00'),
        totalCost: action.payload.totalCost
          ? parseFloat(action.payload.totalCost)
          : parseFloat('0.00'),
      };
    case 'setCheck':
      return { ...state, check: action.payload };
    case 'setWeight':
      return { ...state, weight: parseFloat(action.payload) };
    case 'setCargoCostMnt':
      return { ...state, cargoCostMnt: parseFloat(action.payload) };
    case 'setReceivedDate':
      return { ...state, receivedDate: action.payload };
    case 'setReceivedType':
      return { ...state, receivedType: Number(action.payload) };
    case 'setCustomTaxAmount':
      return { ...state, customTaxAmount: parseFloat(action.payload) };
    case 'calcCargoCost':
      return {
        ...state,
        cargoCostMnt: state.weight * state.cargoFee * state.currencyRate,
      };
    default:
      console.log('Wrong Dispatch: ', action);
  }
}

export default function BoxViewForm(props) {
  const {
    intl,
    actionsLoading,
    dialogMsg,
    dialogError,
    boxForView,
    btnRefSave,
    saveBox,
    onHide,
  } = props;
  const [state, dispatch] = useReducer(reducer, initialBox);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    console.log('boxForView: ', boxForView);
    if (boxForView) dispatch({ type: 'init', payload: boxForView });
  }, [boxForView]);
  useEffect(() => {
    setErr(dialogError);
  }, [dialogError]);
  useEffect(() => {
    setMsg(dialogMsg);
  }, [dialogMsg]);

  const save = (values) => {
    console.log('Save:', values);
    setErr('');
    setMsg('');
    saveBox(values);
  };
  const setCheck = (check) => {
    dispatch({ type: 'setCheck', payload: check });
  };
  const setWeight = (weight) => {
    dispatch({ type: 'setWeight', payload: weight });
    dispatch({ type: 'calcCargoCost', payload: '' });
    //dispatch({ type: 'calcTotalCost', payload: '' });
  };
  const setCargoCostMnt = (cost) => {
    dispatch({ type: 'setCargoCostMnt', payload: cost });
    //dispatch({ type: 'calcTotalCost', payload: '' });
  };
  const setReceivedDate = (receivedDate) => {
    dispatch({ type: 'setReceivedDate', payload: receivedDate });
  };
  const setReceivedType = (receivedType) => {
    dispatch({ type: 'setReceivedType', payload: receivedType });
  };
  const setCustomTaxAmount = (customTaxAmount) => {
    dispatch({ type: 'setCustomTaxAmount', payload: customTaxAmount });
  };

  const handleChange2 = (event) => {};
  const handleChange = (event) => {
    let e = event.target.value;
    setReceivedDate(e);
    if (e === '') setReceivedType(0);
  };
  const saveBoxItems = () => {};

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              <div className='form-group row'>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.TRACKINGID' />
                  </label>
                  <Field
                    name='trackingId'
                    className='form-control form-control-sm'
                    value={state.trackingId}
                    disabled={true}
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <Link to={`/orders/${state.orderCode}/edit`}>
                      <FormattedMessage id='ORDER.LABEL.ORDERDATE' />
                    </Link>
                  </label>
                  <Field
                    name='orderDate'
                    className='form-control form-control-sm'
                    disabled={true}
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.WEBSITE' />
                  </label>
                  <Field
                    name='websiteCode'
                    className='form-control form-control-sm'
                    value={state.websiteCode}
                    disabled={true}
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.BOXSTATUS' />
                  </label>
                  <Select
                    name='boxStatus'
                    className='form-control form-control-sm'
                    disabled={true}
                  >
                    {boxStatusList.map((option) => (
                      <option
                        key={`boxStatusList${option.key}`}
                        value={option.key}
                      >
                        {option.value}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.CARGO' />
                  </label>
                  <Field
                    name='cargoCode'
                    className='form-control form-control-sm'
                    value={state.cargoCode}
                    disabled={true}
                  />
                </div>
                <div className='col-3'>
                  <label>Каргод бүртгэсэн </label>
                  <CheckBox
                    text=''
                    checked={state.check}
                    changeCheckBoxValue={setCheck}
                    disabled={state.check}
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.WEIGHT' />
                  </label>
                  <Numeric
                    name='weight'
                    value={state.weight}
                    onChange={setWeight}
                    className='form-control form-control-sm'
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.CARGOFEE' />
                  </label>
                  <Numeric
                    name='cargoCostMnt'
                    value={state.cargoCostMnt}
                    onChange={setCargoCostMnt}
                    className='form-control form-control-sm'
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.RECEIVEDDATE' />
                  </label>
                  <input
                    id='receivedDate'
                    type='date'
                    className='form-control form-control-sm'
                    value={state.receivedDate}
                    onChange={handleChange}
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.RECEIVEDTYPE' />
                  </label>
                  <Select
                    name='receivedType'
                    className='form-control form-control-sm'
                    onChange={(e) => {
                      setReceivedType(e.target.value);
                    }}
                  >
                    {receivedTypeList.map((option) => (
                      <option
                        key={`receivedTypeList${option.key}`}
                        value={option.key}
                      >
                        {option.value}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.CUSTOMTAXAMOUNT' />
                  </label>
                  <Numeric
                    name='customTaxAmount'
                    value={state.customTaxAmount}
                    className='form-control form-control-sm'
                    onChange={setCustomTaxAmount}
                  />
                </div>
                <div className='col-3'>
                  <label>
                    <FormattedMessage id='BOX.LABEL.TOTALCOST' />
                  </label>
                  <Numeric
                    name='totalCost'
                    value={state.totalCost}
                    className='form-control form-control-sm'
                    disabled={true}
                  />
                </div>
              </div>
              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                onClick={onHide}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>
      {boxForView && <BoxItems box={boxForView} saveBoxItems={saveBoxItems} />}
    </>
  );
}
